
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"fxa-500-header\">{{#t}}500 Error{{/t}}</h1>\n  </header>\n\n  <section>\n    {{#t}}Oh dear, something went wrong there. We've been notified and will get working on a fix.{{/t}}\n  </section>\n</div>\n\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/500.mustache
// module id = 151
// module chunks = app